export default __webpack_public_path__ + "static/media/36.a43f1bc4.jpg";